export default __webpack_public_path__ + "static/media/SA.ff9716b3.svg";